import React, { useCallback } from 'react';
import styled from 'astroturf/react';

import { createUserFollowing } from 'js/social/api/user_following_api';
import { FollowableUser } from 'js/social/shared/types';
import Avatar from 'js/social/shared/Avatar';
import { FollowActionButton } from 'js/social/shared/FollowActionButton';
import { FeedPostsActions } from 'js/social/News/useNewsInteractions';
import _Banner from "PostEngagementFollowPrompt-Banner.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/PostEngagementFollowPrompt.tsx?styleId=Banner";
import _AvatarMessageContainer from "PostEngagementFollowPrompt-AvatarMessageContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/PostEngagementFollowPrompt.tsx?styleId=AvatarMessageContainer";
import _AvatarStyled from "PostEngagementFollowPrompt-AvatarStyled.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/PostEngagementFollowPrompt.tsx?styleId=AvatarStyled";
import _FollowButton from "PostEngagementFollowPrompt-FollowButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/PostEngagementFollowPrompt.tsx?styleId=FollowButton";


export type PostEngagementFollowPromptProps = Pick<
  FeedPostsActions,
  'setUserFollowing'
> & {
  user: FollowableUser;
  followSource?: string;
  followSourceDetails?: { [key: string]: string | number | undefined };
};

const Banner = /*#__PURE__*/styled("div", null, {
  displayName: "Banner",
  styles: _Banner
});

const AvatarMessageContainer = /*#__PURE__*/styled("div", null, {
  displayName: "AvatarMessageContainer",
  styles: _AvatarMessageContainer
});

const AvatarStyled = /*#__PURE__*/styled(Avatar, null, {
  displayName: "AvatarStyled",
  styles: _AvatarStyled
});

const FollowButton = /*#__PURE__*/styled(FollowActionButton, null, {
  displayName: "FollowButton",
  styles: _FollowButton
});

export const PostEngagementFollowPrompt: React.FC<PostEngagementFollowPromptProps> =
  ({
    user: { id: userId, following, photo, displayName, url },
    setUserFollowing,
    followSource = 'social_post_engagement_prompt',
    followSourceDetails,
  }) => {
    const handleFollow = useCallback(async () => {
      await createUserFollowing(userId, followSource, followSourceDetails);
      setUserFollowing(userId, true);
    }, [userId, setUserFollowing, followSourceDetails, followSource]);

    return (
      <Banner>
        <AvatarMessageContainer>
          <AvatarStyled
            className={'clickable'}
            photoUrl={photo}
            fullName={displayName}
            profileUrl={url}
          />
          {`Follow ${displayName} to see more posts like this`}
        </AvatarMessageContainer>
        <FollowButton
          userId={userId}
          follows={following}
          onFollow={handleFollow}
          size="xs"
          variant="primary"
        />
      </Banner>
    );
  };
